// What build this is. Stamped at build time by scripts/gate1/build-web.mjs
// (locally) or the CI workflow; recorded in every log and trace marker, and
// shown on the debug screen only.
export const BUILD = Object.freeze({
    commit: process.env.REACT_APP_COMMIT_REF || 'unknown',
    buildType: process.env.REACT_APP_BUILD_TYPE || (process.env.NODE_ENV === 'production' ? 'release' : 'debug'),
    nodeEnv: process.env.NODE_ENV,
    builtAt: process.env.REACT_APP_BUILT_AT || null,
})

// Debug logging: compiled to a no-op in release builds.
export const debugLog = BUILD.buildType === 'release'
    ? () => {}
    : (...args) => console.log('[gate1]', ...args) // eslint-disable-line no-console
